import Vue from 'vue'
import Router from 'vue-router'
import store from '@/store'
import { concat } from 'lodash'
import {check_login} from '@/helper/function'

import RouterLog from '@/components/log/router'
import RouterIndex from '@/components/index/router'
import RouterTemplate from '@/components/template/router'
import RouterSalary from '@/components/salary/router'
import RouterLogin from '@/components/login/router'

Vue.use(Router)

export default new Router({
  mode: 'history',
  routes: concat(
		RouterIndex,
    RouterTemplate,
		RouterLog,
    RouterSalary,
    RouterLogin
  )
})
